import Dropdown from 'app/components/Dropdown';
import MultiSelectDropdown from 'app/components/MultiSelectDropdown';
import SearchableDropdown from 'app/components/SearchableDropdown';
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import NewAttachment from 'app/components/NewAttachment';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import TextArea from 'app/components/Textarea';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import { commonMaxDate, commonMinDate } from 'app/utils/Parsers';
import Toggle from 'react-toggle';
import useCreateVoucher from './useCreateVoucher';

const TOGGLE_CONFIG = [
  // Quick task 260903-fdd (D-1): placed first so it sits beside Reserve for
  // Game rather than after the Status toggle.
  { key: 'isSpecialVoucher', label: 'Special Voucher' },
  { key: 'isGamificationVoucher', label: 'Reserve for Game' },
  { key: 'visible', label: 'Visible in App*' },
  { key: 'status', label: 'Status*' },
];

const CreateVoucher = () => {
  const {
    voucherTermsConditions,
    handleMallChange,
    tierIdsOptions,
    storeList,
    storeId,
    mallList,
    handleChange,
    handleTierChange,
    values,
    error,
    handleCreateVoucher,
    pageLoading,
    uploadMediaHandler,
    setChange,
    navigate,
  } = useCreateVoucher();
  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${storeId ? ' Edit Voucher  ' : 'Create Voucher'}`}
          goTo={APP_CONSTANTS.VOUCHER}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <Dropdown
              id={'mallId'}
              label='Mall name*'
              name='mallId'
              options={mallList}
              placeholder='Select Mall '
              value={values.mallId}
              handleChange={handleMallChange}
              errorText={error?.mallId}
            />
          </div>
          <div className='wd-50'>
            <SearchableDropdown
              id='storeId'
              label='Store name*'
              name='storeId'
              options={storeList}
              placeholder='Search store...'
              value={values.storeId}
              handleChange={handleChange}
              errorText={error?.storeId}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Voucher title*'
              id='voucherTitle'
              type='text'
              placeholder='Voucher title'
              name='voucherTitle'
              value={values?.voucherTitle}
              onChange={handleChange}
              errorText={error?.voucherTitle}
            />
          </div>

          <div className='wd-50'>
            <label>Voucher Promotional Image </label>
            <NewAttachment
              value={values?.promotionalImage}
              id='promotionalImage'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              alt='promotionalImage'
              errorText={error?.promotionalImage}
            />
          </div>
          <div className='wd-100'>
            <TextArea
              label='Description*'
              id='description'
              type='text'
              placeholder='Description'
              name='description'
              value={values?.description}
              onChange={handleChange}
              errorText={error?.description}
            />
          </div>

          <div className='wd-50'>
            <MultiSelectDropdown
              id='tierIds'
              label='Select Tier'
              name='tierIds'
              options={tierIdsOptions}
              value={values.tierIds}
              onChange={handleTierChange}
              asterisk={true}
            />
            {error?.tierIds && (
              <span className='loginWrapper-valid-text'>{error.tierIds}</span>
            )}
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Usage Limit*'
              id='usageLimit'
              placeholder='Enter usage limit'
              name='usageLimit'
              value={values?.usageLimit}
              onChange={handleChange}
              errorText={error?.usageLimit}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Loyalty Points*'
              id='loyaltyPoints'
              placeholder='Enter loyalty points'
              name='loyaltyPoints'
              value={values?.loyaltyPoints}
              onChange={handleChange}
              errorText={error?.loyaltyPoints}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Frequency*'
              id='frequency'
              placeholder='Enter frequency'
              name='frequency'
              value={values?.frequency}
              onChange={handleChange}
              errorText={error?.frequency}
            />
          </div>
          <div className='wd-100'>
            <MultiSelectDropdown
              id='termsOfUsage'
              label='Terms of Usage*'
              name='termsOfUsage'
              options={voucherTermsConditions}
              value={values.termsOfUsage}
              onChange={handleChange}
              asterisk={true}
            />
            {error?.termsOfUsage && (
              <span className='loginWrapper-valid-text'>{error.termsOfUsage}</span>
            )}
          </div>

          <div className='wd-50'>
            <NumberInput
              label='Voucher Count*'
              id='voucherCount'
              placeholder='Enter voucher count'
              name='voucherCount'
              value={values?.voucherCount}
              onChange={handleChange}
              errorText={error?.voucherCount}
            />
          </div>
          <div className='wd-50'>
            <NumberInput
              label='Sort Order'
              id='sortOrder'
              placeholder='0 = normal (leave blank for no priority)'
              name='sortOrder'
              value={values?.sortOrder}
              onChange={handleChange}
              errorText={error?.sortOrder}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Voucher Type*'
              id='voucherType'
              type='text'
              placeholder='Enter voucher type'
              name='voucherType'
              value={values?.voucherType}
              onChange={handleChange}
              errorText={error?.voucherType}
            />
          </div>
          <div className='wd-100'>
            <TextArea
              label='How To Redeem*'
              id='howToRedeem'
              type='text'
              placeholder='Enter how to redeem'
              name='howToRedeem'
              value={values?.howToRedeem}
              onChange={handleChange}
              errorText={error?.howToRedeem}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Voucher Validity Start Date*'
              id='startDate'
              placeholder='DD-YY-MMMM'
              name='startDate'
              format='DD-MM-YYYY'
              type={'date'}
              min={commonMinDate()}
              max={commonMaxDate()}
              value={values?.startDate}
              onChange={handleChange}
              errorText={error?.startDate}
            />
          </div>
          <div className='wd-50'>
            <NewInput
              label='Voucher Validity Expiry Date*'
              name='endDate'
              id='endDate'
              placeholder={'End Date'}
              min={values.startDate ? values.startDate : commonMinDate()}
              max={commonMaxDate()}
              value={values?.endDate}
              type={'date'}
              onChange={handleChange}
              errorText={error?.endDate}
            />
          </div>

          <div className='wd-100 toggle-group'>
            {TOGGLE_CONFIG.map(({ key, label }) => (
              <div className='toggle-card' key={key}>
                <div className='toggle-card_header'>
                  <span className='toggle-card_label tooltip-on-hover'>
                    {label}
                  </span>
                  <span
                    className={`toggle-card_badge ${
                      values[key] ? 'is-on' : 'is-off'
                    }`}
                  >
                    {values[key] ? 'Active' : 'Inactive'}
                  </span>
                </div>
                <Toggle
                  checked={values[key]}
                  icons={false}
                  onChange={() => setChange(key, !values[key])}
                />
              </div>
            ))}
            {/* Quick task 260903-fdd (D-5): the toggle map above renders no
                error slot at all, so the inline cross-field message (mirroring
                the existing All-tier x Reserve-for-Game guard, which surfaces
                through MultiSelectDropdown's errorText) needed one added. */}
            {error?.isSpecialVoucher && (
              <p className='loginWrapper-valid-text toggle-group_error'>
                {error.isSpecialVoucher}
              </p>
            )}
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateVoucher}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateVoucher;
